module.exports = __webpack_public_path__ + "static/img/ksyz.74fc73e3.png";